import React, { useState } from 'react'
import BrandLogo from '../assets/images/logo2n.png';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaLinkedinIn, FaXTwitter, FaInstagram, FaYoutube, FaFacebookF } from 'react-icons/fa6';

// Social profiles shown in the footer. Update hrefs here if links change.
const SOCIAL_LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/jaggulasconsulting/', Icon: FaLinkedinIn },
  { label: 'Twitter / X', href: 'https://x.com/jaggulas_c', Icon: FaXTwitter },
  { label: 'Instagram', href: 'https://www.instagram.com/jaggulas.consulting/', Icon: FaInstagram },
  { label: 'YouTube', href: 'https://www.youtube.com/@JaggulasConsulting', Icon: FaYoutube },
  { label: 'Facebook', href: 'https://www.facebook.com/p/Jaggulas-Consulting-100090528977653/', Icon: FaFacebookF },
];

// Pillar headings shown in the footer; click a pillar to reveal its sub-services.
// Labels mirror the homepage services section. Each id maps to a section in Services.jsx.
const FOOTER_SERVICES = [
  {
    pillar: 'AI Solutions',
    items: [
      { id: 'ai-agents', label: 'AI Agents' },
      { id: 'generative-ai-development', label: 'Generative AI Development' },
      { id: 'ai-automation', label: 'AI Automation' },
      { id: 'ai-consulting', label: 'AI Consulting' },
    ],
  },
  {
    pillar: 'Cloud & DevOps',
    items: [
      { id: 'cloud-migration-modernization', label: 'Cloud Migration & Modernization' },
      { id: 'aws-managed-services', label: 'AWS Managed Services & FinOps' },
      { id: 'cloud-security-audits', label: 'Cloud Security & Audits' },
      { id: 'devops-platform-engineering', label: 'DevOps & Platform Engineering' },
    ],
  },
  {
    pillar: 'Software & Data Engineering',
    items: [
      { id: 'custom-software-web-applications', label: 'Custom Software Web & Mobile Apps' },
      { id: 'backend-api-integration', label: 'Backend & API Integration' },
      { id: 'data-engineering-analytics', label: 'Data Engineering & Analytics' },
    ],
  },
  {
    pillar: 'Technology Consulting',
    items: [
      { id: 'cloud-digital-transformation-strategy', label: 'Digital Transformation Strategy' },
      { id: 'cto-advisory-architecture-consulting', label: 'CTO Advisory & Architecture' },
    ],
  },
];

export default function Footer() {
  const [openPillar, setOpenPillar] = useState(null);

  return (
    <div className='FooterBg p-5 border-top border-secondary'>
      <div className="container">
        <div className="row py-3 d-flex justify-content-center g-5 text-start">
          <div className="col-sm-6 col-md-3 px-4">
            <h5 className='about-heading'>Who We Are</h5>
            <p className='small'>At Jaggulas Consulting, our business is about providing to our Clients, Software Development and Cloud Services. Our commitment to excellence and integrity sets us apart from other IT service providers <Link to="/About" className='read-more'>read more...</Link></p>
          </div>
          <div className=" col-sm-6 col-md-3 px-4">
          <h5 className='about-heading'>Quick Links</h5>
            <p> <Link to="/" className='link-text small'>Home</Link> </p>
            <p> <Link to="/Services" className='link-text small'>Services</Link> </p>
            <p> <Link to="/About" className='link-text small'>Who We Are</Link> </p>
            <p> <Link to="/Careers" className='link-text small'>Careers</Link> </p>
            <p> <Link to="/Contact" className='link-text small'>Contact</Link> </p>
          </div>
          <div className="col-sm-6 col-md-3 px-4">
            <h5 className='about-heading'>Services</h5>
            <ul className="footer-services">
              {FOOTER_SERVICES.map((group, i) => (
                <li key={group.pillar} className="footer-service-group">
                  <button
                    type="button"
                    className={"footer-pillar" + (openPillar === i ? " open" : "")}
                    onClick={() => setOpenPillar(openPillar === i ? null : i)}
                  >
                    {group.pillar}
                  </button>
                  {openPillar === i && (
                    <ul className="footer-sublist">
                      {group.items.map((svc) => (
                        <li key={svc.id}>
                          <HashLink to={`/Services#${svc.id}`} className='link-text small'>{svc.label}</HashLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-sm-6 col-md-3 px-4">
          <h5 className='about-heading'>Contact Us</h5>
            <p className='small'> business@jaggulasconsulting.com</p>
            <p className='small'>+27 740687900</p>
            <p className='small'>+91 8143482337</p>
          </div>
        </div>

        <div className="row text-center d-flex justify-content-center">
          <img src={BrandLogo} alt="Jaggulas Consulting Logo" className='FooterLogo py-sm-3 py-2' />

          <div className="footer-socials d-flex justify-content-center">
            {SOCIAL_LINKS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="footer-social-icon"
              >
                <Icon />
              </a>
            ))}
          </div>

          <div className='small'> &copy; 2024 - {(new Date().getFullYear())} Jaggulas Consulting | <Link to='/PrivacyPolicy'>Privacy Policy</Link></div>

        </div>
      </div>


    </div>
  )
}
